import { render } from "./AdaptationTable.vue?vue&type=template&id=3080c5e8&scoped=true"
import script from "./AdaptationTable.vue?vue&type=script&lang=js"
export * from "./AdaptationTable.vue?vue&type=script&lang=js"

import "./AdaptationTable.vue?vue&type=style&index=0&id=3080c5e8&scoped=true&lang=css"
import "./AdaptationTable.vue?vue&type=style&index=1&id=3080c5e8&lang=css"

import exportComponent from "C:\\wamp64\\www\\tafe-raap-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3080c5e8"]])

export default __exports__